<template>
  <div class="c-record-cp">
    <!-- filter -->
    <design-expend-filter
      :drop-medias="dropMedias"
      :agent-data="agentData"
      @on-down="downExcel"
      @on-import="importExcel"
      @on-change="filterData"
    />
    <!-- table @on-edit="addRecord" -->
    <div class="c-table-list">
      <Viewport v-model="tableHeight" v-loading="loading">
        <design-expend-table
          :height="tableHeight"
          :data="tableList"
          :columns="tableCol"
          @on-save="saveRecord"
          @on-del="delRecord"
          @on-refresh="getData"
        />

        <el-pagination
          :total="total"
          :current-page.sync="pageIndex"
          :page-size="pageSize"
          :page-sizes="[10, 20, 30, 40, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          @current-change="changePageIndex"
          @size-change="changePageSize"
          class="c-table-page pager"
          background
        />
      </Viewport>
    </div>

    <resulter
      v-model="resultModel"
      type="素材消耗"
      :add-total="added"
      :update-total="updated"
      :fail-total="failure"
      :req="req_id"
      @on-close="resultOk"
      @on-down="downFailExecl"
    />
  </div>
</template>
<script>
import mixin from '../mixins/mixin'
import columns from '../data/design_expend_column'
import { setLocal, getLocal, mul } from '@/common/js/api'
import { isArray, isEmpty } from '@/common/js/utils'
import { HOST_API } from '@/api/config'
import { getSysMember, getSysMedia } from '@/api/common.model'
import { getDesignDetailList, delDesignExpend, uploadDesignExpend, importExpendExcel } from '@/api/manage.model'
import DesignExpendFilter from './components/design-expend-filter'
import DesignExpendTable from './components/design-expend-table'
import Resulter from './components/result-dialog'

export default {
  name: 'recordCp',
  mixins: [mixin],
  components: { DesignExpendFilter, DesignExpendTable, Resulter },
  methods: {
    getData(filter) {
      let params = {
        page_id: this.pageIndex,
        page_size: this.pageSize,
        keyWord: this.params && this.params.keyWord,
        type: 2
      }
      if (filter) params = Object.assign(params, filter)
      else params = Object.assign(this.params, params)
      this.params = JSON.parse(JSON.stringify(params))
      this.loading = true
      getDesignDetailList(params)
        .then((data) => {
          this.loading = false
          if (!data) return
          const { list, page_info } = data
          if (isArray(list) && page_info) {
            const { total_number } = page_info
            this.total = total_number || 0
            this.tableList = list
          }
        })
        .catch((err) => {
          this.$Message.error({
            duration: 5,
            content: err
          })
        })
    },
    importExcel(file) {
      this.$Spin.show()
      importExpendExcel({ file }).then((data) => {
        this.$Spin.hide()
        if (data) {
          this.resultModel = true
          this.added = data.addTotal
          this.failure = data.failTotal
          this.updated = data.updateTotal
          this.req_id = data.requestId
        }
      })
    },
    saveRecord(params) {
      const { imageId, mediaId, newThirtyDaysAmount } = params
      const thirtyDaysAmount = newThirtyDaysAmount
      const { err, msg } = this.vaild({ imageId, mediaId, thirtyDaysAmount })
      if (err) {
        this.$Message.error({
          duration: 5,
          content: msg
        })
        return
      }
      this.$set(params, 'loading', true)
      uploadDesignExpend({
        media_id: mediaId,
        image_id: imageId,
        thirty_days_amount: thirtyDaysAmount
      }).then((data) => {
        this.$set(params, 'loading', false)
        if (data) {
          this.pageIndex = 1
          this.model = false
          this.getData()
        }
      })
    },
    delRecord(row) {
      const { mediaId, imageId } = row
      delDesignExpend({
        media_id: mediaId,
        image_id: imageId
      }).then((data) => {
        if (data) this.getData()
      })
    },
    vaild(params) {
      const keys = Object.keys(params)
      const value = { imageId: '素材ID', thirtyDaysAmount: '30天实际消耗' }
      let err = false
      let msg = ''

      keys.some((ret) => {
        if (!isEmpty(params[ret])) {
          if (ret === 'thirtyDaysAmount') {
            const val = parseFloat(params[ret])
            if (isNaN(val) || Math.ceil(mul(val, 100)) !== mul(val, 100) || val > 99999999 || val <= 0) {
              msg = `${value[ret]}应大于0，小于99999999.00，最多2位小数`
              err = true
              return false
            }
          }
        } else {
          msg = `${value[ret]}不能为空`
          err = true
          return false
        }
      })

      return { err, msg }
    },
    downExcel() {
      window.open(`${HOST_API}/api/ptom/template/downTemplate?templateType=template_ptom_material_cost`, '_blank')
    },
    downFailExecl(req) {
      window.open(`${HOST_API}/api/ptom/designkpi/import/downloadError?requestId=${req}`)
    },
    setLocalPage(size) {
      setLocal('DESIGN_EXPEND_PAGESIZE', size)
    },
    resultOk() {
      this.resultModel = false
      this.pageIndex = 1
      this.getData()
    },
    preLoadData() {
      Promise.all([getSysMedia(), getSysMember()])
        .then((data) => {
          const [mediaData, agentData] = data
          if (isArray(mediaData)) {
            this.dropMedias = mediaData.map((ret) => {
              return {
                id: ret.mediaId,
                name: ret.mediaName
              }
            })
          }
          isArray(agentData) && (this.agentData = agentData)
        })
        .catch((error) => {
          this.$Message.error({
            duration: 5,
            content: error
          })
        })
    }
  },
  created() {
    this.pageSize = parseInt(getLocal('DESIGN_EXPEND_PAGESIZE')) || 20
    this.tableCol = columns
    this.preLoadData()
  },
  data() {
    return {
      tableHeight: 330,
      loading: null,
      dropMedias: [],
      agentData: [], // 所有人员
      resultModel: null,
      added: 0,
      failure: 0,
      updated: 0,
      req_id: ''
    }
  }
}
</script>
<style lang="scss" scoped>
.c-table-page {
  padding: 5px 0;
  text-align: right;
}
</style>
